const contactConfig = {
  YOUR_EMAIL: "finepiver@gmail.com",
  YOUR_FONE: "0741-575-628",
  description:
    "We are always available feel free to talk to us. It is always a pleasure meeting new clients and growing together. We apreciate you alot for visiting our website ",
  YOUR_SERVICE_ID: "service_id",
  YOUR_TEMPLATE_ID: "template_id",
  YOUR_USER_ID: "user_id",
};

export { contactConfig };
